<section id="successTransaction">
  <div class="row justify-content-center align-items-center">
    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-10 align-self-center">
      <div class="transaction-status-container">
        <mat-card class="text-center">
          <div class="feature-icon">
            <section [angularLottie]="successJson" [loop]="true"></section>
          </div>
          <h6 class="feature-prompt">Hurray!</h6>
          <h4 class="feature-title">
            Promo code {{ promocode }} was sent successfully
          </h4>
          <div class="actions-blk">
            <ul class="list-group border-0 px-5">
              <li class="list-group-item border-0 bg-transparent">
                <button
                  mat-flat-button
                  color="accent"
                  class="w-100 py-1 text-dark  cur-point"
                  [routerLink]="['../../ocassion-rewards/festival-promo']"
                  routerLinkActive="router-link-active"
                >
                  Generate another promo code
                </button>
              </li>
              <li class="list-group-item border-0 bg-transparent">
                <button
                  mat-flat-button
                  color="accent"
                  class="w-100 py-1 text-dark  cur-point"
                  [routerLink]="['../../ocassion-rewards/promo-history']"
                  routerLinkActive="router-link-active"
                >
                  View promo code history
                </button>
              </li>
            </ul>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</section>
